import { useMemo } from "react";
import Select from "react-select";

import CustomInput from "./CustomInput";

export type OptionType = {
  label: string;
  value: string | number | boolean;
};

type MultiSelectColumnInputProps = {
  onChange: Function;
  label?: string;
  value?: (OptionType | string | number | boolean)[];
  id?: string;
  name?: string;
  options: (OptionType | string | number | boolean)[];
};

function normalizeToOptionTypeArray(
  arr: (string | number | boolean | OptionType)[]
): OptionType[] {
  if (!arr || arr.length === 0) {
    return [];
  }

  return arr.map((item) => ({
    label: String(item),
    value:
      typeof item === "object" && item !== null && "value" in item
        ? (item as OptionType).value
        : item,
  }));
}

const MultiSelectColumnInput = (props: MultiSelectColumnInputProps) => {
  const { onChange, label, value = [], id, options, name } = props;

  const isOptionArray = useMemo(
    () =>
      Array.isArray(options) &&
      options.length > 0 &&
      typeof options[0] === "object" &&
      options[0] !== null &&
      "label" in options[0] &&
      "value" in options[0],
    [options]
  );

  return (
    <CustomInput label={label} id={id}>
      <Select
        name={name || id}
        options={isOptionArray ? options : normalizeToOptionTypeArray(options)}
        value={isOptionArray ? value : normalizeToOptionTypeArray(value)}
        isMulti={true}
        onChange={(value) =>
          onChange(
            isOptionArray
              ? value
              : value.map((option) =>
                  typeof option === "object" &&
                  option !== null &&
                  "value" in option
                    ? (option as OptionType).value
                    : option
                )
          )
        }
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary25: "var(--blue10)",
            primary50: "var(--blue15)",
            primary75: "var(--blue25)",
            primary: "var(--blue)",

            dangerLight: "var(--lightNoteRed)",
            danger: "var(--red)",
          },
        })}
        className="CustomInput__container__multiSelect"
        classNamePrefix="CustomInput__container__multiSelect"
      />
    </CustomInput>
  );
};

export default MultiSelectColumnInput;
